import { render, staticRenderFns } from "./DocumentsCard.vue?vue&type=template&id=3aebea9e&scoped=true"
import script from "./DocumentsCard.vue?vue&type=script&lang=js"
export * from "./DocumentsCard.vue?vue&type=script&lang=js"
import style0 from "./DocumentsCard.vue?vue&type=style&index=0&id=3aebea9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aebea9e",
  null
  
)

export default component.exports